export const EnIcon = () => {
  return (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_8525_2561" maskUnits="userSpaceOnUse" x="0" y="4" width="24" height="16">
  <path d="M22 4H2C0.895431 4 0 4.89543 0 6V18C0 19.1046 0.89543 20 2 20H22C23.1046 20 24 19.1046 24 18V6C24 4.89543 23.1046 4 22 4Z" fill="white"/>
  </mask>
  <g mask="url(#mask0_8525_2561)">
  <path d="M24 4H0V20H24V4Z" fill="#0A17A7"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.72032 14.6666H-2.71797e-05V9.33329H5.72032L-2.37744 4.23541L-1.09929 2.4668L9.14283 8.91463V2.93329H14.8571V8.91463L25.0992 2.4668L26.3774 4.23541L18.2796 9.33329H24V14.6666H18.2796L26.3774 19.7645L25.0992 21.5331L14.8571 15.0853V21.0666H9.14283V15.0853L-1.09929 21.5331L-2.37744 19.7645L5.72032 14.6666Z" fill="white"/>
  <path d="M16.001 9.06578L26.857 2.40002" stroke="#DB1F35" stroke-width="0.666667" stroke-linecap="round"/>
  <path d="M17.1538 14.9581L26.8857 21.0803" stroke="#DB1F35" stroke-width="0.666667" stroke-linecap="round"/>
  <path d="M6.8621 9.04836L-3.28906 2.66321" stroke="#DB1F35" stroke-width="0.666667" stroke-linecap="round"/>
  <path d="M7.9631 14.8839L-3.28906 21.8484" stroke="#DB1F35" stroke-width="0.666667" stroke-linecap="round"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 13.6H10.2857V20H13.7143V13.6H24V10.4H13.7143V4H10.2857V10.4H0V13.6Z" fill="#E6273E"/>
  </g>
</svg>
  )
}